import Footer from "./Footer";
import Restaurants from "./Restaurants";
import Header from "./Header";

const Body = () => {
  return (
    <>
      <Header />
      <Restaurants />
      <Footer />
    </>
  );
};

export default Body;
